/* tslint:disable */
/* eslint-disable */
/**
 * Immutable X API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@immutable.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { WidgetParams } from './widget-params';

/**
 * 
 * @export
 * @interface CreateExchangeAndURLAPIRequest
 */
export interface CreateExchangeAndURLAPIRequest {
    /**
     * Provider name
     * @type {string}
     * @memberof CreateExchangeAndURLAPIRequest
     */
    'provider'?: CreateExchangeAndURLAPIRequestProviderEnum;
    /**
     * Transaction type
     * @type {string}
     * @memberof CreateExchangeAndURLAPIRequest
     */
    'type'?: CreateExchangeAndURLAPIRequestTypeEnum;
    /**
     * Ethereum address of the user who wants to create transaction
     * @type {string}
     * @memberof CreateExchangeAndURLAPIRequest
     */
    'wallet_address'?: string;
    /**
     * 
     * @type {WidgetParams}
     * @memberof CreateExchangeAndURLAPIRequest
     */
    'widget'?: WidgetParams;
}

export const CreateExchangeAndURLAPIRequestProviderEnum = {
    Moonpay: 'moonpay',
    Layerswap: 'layerswap'
} as const;

export type CreateExchangeAndURLAPIRequestProviderEnum = typeof CreateExchangeAndURLAPIRequestProviderEnum[keyof typeof CreateExchangeAndURLAPIRequestProviderEnum];
export const CreateExchangeAndURLAPIRequestTypeEnum = {
    Onramp: 'onramp',
    Offramp: 'offramp'
} as const;

export type CreateExchangeAndURLAPIRequestTypeEnum = typeof CreateExchangeAndURLAPIRequestTypeEnum[keyof typeof CreateExchangeAndURLAPIRequestTypeEnum];


